export default "__VITE_ASSET__kR5B0KUU__"